<template>
  <div class="yunshui-mask" v-if="showCalendar">
    <div class="calendar">
      <div class="content" @tap.stop>
        <div class="title choose-title" :style="TitleStyle">
          {{isActive?'阳历:'+chooseYear.text+chooseMonth.text+chooseDay.text+chooseHour.text:'农历:'+chooseYear.text+chooseMonth.text+chooseDay.text+chooseHour.text}}
        </div>
        <div class="title">
          <div class="switch" :style="{border:'1px solid '+ tabBorderColor}">
            <div class="left" 
            :style="type === 'solar'?tabActive:'color:'+tabActive.background"
            @click="switchBtn('solar')">公历</div>
            <div class="right" 
            :style="type === 'lunar'?tabActive:'color:'+tabActive.background" @click="switchBtn('lunar')">农历</div>
            <div class="bg" :class="type"></div>
          </div>
          <!-- <div class="ignore-year">忽略年份</div> -->
        </div>
        <div class="time-content" style="padding: 0 10px;width:96%;">
        <div class="time-list">
          <div class="time-item">
            <ScrollSelect   @change="yearsChange" 
            :isChange="isActive"
            :chooseItem="chooseItem"
            :options="years"></ScrollSelect> 
          </div>
          <div class="time-item">
            <ScrollSelect 
            @change="monthsChange" 
            :isChange="isActive"
            :chooseItem="chooseItem"
            :options="months"></ScrollSelect> 
          </div>
          <div class="time-item">
            <ScrollSelect 
            @change="daysChange" 
            :isChange="isActive"
            :chooseItem="chooseItem"
            :options="days"></ScrollSelect>
          </div>
          <div class="time-item" v-if="isHour">
            <ScrollSelect 
            @change="lunarHourChange"
            :isChange="isActive"
            :chooseItem="chooseItem"
            :options="lunarHour"></ScrollSelect>
          </div>
    </div>
  </div>
        <div class="bottom" v-if="isSwitch">
          <div class="left" :style="cancelStyle" @click="cancel">取消</div>
          <div class="right" :style="confirmStyle" @click="sure">确定</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import conversion from './calendar.js'
import lunarHour from './information.js'
import ScrollSelect from './ScrollSelect.vue'
export default {
  name: 'YunshiCalendar',
  data() {
    return {
      oldYear: 1920, // 最大年份
      type: 'solar', // lunar农历，solar公历
      isActive: true, // true公历
      showData: '', // 显示数据
      checked: true,
      years: [],
      months: [],
      days: [],
      // indicatorStyle: `height: ${Math.round(uni.getSystemInfoSync().screenWidth / (750 / 100))}px;`,
      lunarHour: [],
      date: '',
      hour: '',
      leap_month: 0, // 1为闰月0为非闰月
      sureYear: '1920', // 默认弹出显示年份
      sureMonth: '10', // 默认弹出显示月份
      sureDay: '1920', // 默认弹出显示年份
      sureHour: '10', // 默认弹出显示月份
      selectValue: [48, 9, 15, 1], // 默认弹出选择的状态1998-10-16 0
      showYear: '',
      showMonth: '',
      nextFinally: true,
      defaultYear:'1920',
      chooseYear:{
        value:1920,
        text:'1920年'
      },
      chooseMonth:{
        value:1,
        text:'1月'
      },
      chooseDay:{
        value:1,
        text:'1日'
      },
      chooseHour:{
        value:24,
        text:''
      }
    }
  },
  components:{ScrollSelect},
  props: {
    isHour:{
      type:Boolean,
      default:true
    },
    isActive1:{
      type:Boolean,
      default:true
    },
    type1:{
      type:String,
      default:'solar'
    },
    
    showCalendar: {
      type: Boolean,
      default: () => false,
    },
    isHourShow: {
      type: Boolean,
      default: true,
    },
    isSwitch: {
      type: Boolean,
      default: true,
    },
    selectOptions: {
      type: Array,
      default: () => [48, 9, 15, 1],
    },
    // 标题样式
    TitleStyle:{
      type:Object,
      default:() => ({})
    },
    // tab边框
    tabBorderColor:{
      type:String,
      default:'#1989fa'
    },
    // 活跃时tab样式
    tabActive:{
      type:Object,
      default:()=>({
        color:'#fff',
        background:' #1989fa'
      })
    },
    // 取消按钮样式
    cancelStyle:{
      type:Object,
      default:()=> ({
        color: '#a6a6a6'
      })
    },
    // 完成按钮样式
    confirmStyle:{
      type:Object,
      default:() => ({
        color: '#fff',
        background:'#1989fa'
      })
    },
    // 选中项的样式
    chooseItem:{
      type:Object,
      default:()=> ({
        color:'#1989fa'
      })
    }
  },
  watch: {
    showCalendar(newVal) {
      if (newVal) this.getTime()
    },
    selectOptions(newVal) {
      console.log('修改了默认值需要回显', newVal)
      this.selectValue = newVal
    },
    isActive1(newVal) {
      this.isActive = newVal
      this.months=[]
      this.days=[]
      if(newVal){
        this.switchBtn('solar')
        this.getlunarMonthDays(this.chooseYear.value,this.chooseMonth.value,this.chooseDay.value)
        this.chooseMonth.text='1月'
        this.chooseDay.text='1日'
        this.chooseYear.text='1920年'
      }else{
        this.switchBtn('lunar')
        this.getsolarMonthDays(this.chooseYear.value,this.chooseMonth.value,this.chooseDay.value)
        this.chooseMonth.text='正月'
        this.chooseDay.text='初一'
        this.chooseYear.text='一九二零年'
      }
      this.$forceUpdate()
    },
    type1(newVal) {
      this.type = newVal
    },
  },
  created() {
    this.getTime()
  },
  mounted() {
    this.defaultYear = 1920
  },
  methods: {
    daysInput() {
      
    },
    // 选择年份
    yearsChange(e) {
      this.chooseYear = e
      this.months=[]
      this.days=[]
      if(!this.isActive){
        this.getlunarMonthDays(this.chooseYear.value,this.chooseMonth.value,this.chooseDay.value)
      }else{
        this.getsolarMonthDays(this.chooseYear.value,this.chooseMonth.value,this.chooseDay.value)
      }
      this.$forceUpdate()
    },
       // 选择月份
    monthsChange(e) {
      this.chooseMonth = e
      this.months=[]
      this.days=[]
      if(!this.isActive){
        if(this.chooseMonth.value>20){
          this.getlunarMonthDays(this.chooseYear.value,this.chooseMonth.value-20,this.chooseDay.value)
        }else{
          this.getlunarMonthDays(this.chooseYear.value,this.chooseMonth.value,this.chooseDay.value)
        }
        
      }else{
        this.getsolarMonthDays(this.chooseYear.value,this.chooseMonth.value,this.chooseDay.value)
      }
        this.$forceUpdate()
    },
       // 选择天
    daysChange(e) {
      this.chooseDay = e
      this.$forceUpdate()
    },
       // 选择小时
       lunarHourChange(e) {
        this.chooseHour = e
      
    },
    cancel() {
   
      this.$emit('cancel')
    },
    // 提交
    sure() {
      if (!this.nextFinally) {
        console.log('别着急，正在选时间')
        return false
      }
      // let data = {
      //   text: this.showData, // 显示数据
      //   type: this.type,
      //   brithday: {
      //     'brithday[date]': this.date,
      //     'brithday[hour]': this.hour,
      //     'brithday[type]': this.type,
      //     // "brithday[leap_month]":this.leap_month,
      //   },
      //   newBirthday: {
      //     brithday: {
      //       date: this.date,
      //       hour: this.hour,
      //       type: this.type,
      //     },
      //   },
      //   date: this.date,
      //   hour: this.hour || 0,
      //   year: this.showYear,
      //   month: this.coverTo(Number(this.showMonth)),
      //   day: this.coverTo(this.selectValue[2] + 1),
      // }
      let type  = this.isActive?0:1
      let data = {
        chooseYear: this.chooseYear,
        chooseMonth:this.chooseMonth,
        chooseDay:this.chooseDay,
        chooseHour:this.chooseHour,
        type:type
      }
      // if (this.type == 'lunar') {
      //   data.brithday['brithday[leap_month]'] = this.leap_month
      //   data.newBirthday.brithday.leap_month = this.leap_month
      //   data.leap_month = this.leap_month
      // }
      this.$emit('confirm', data)
      this.nextFinally = true
    },
    // 进来获取公历的1990-02-10 10,初始化
    getTime() {
      const date = new Date()
      this.years = []
      this.days = []
      this.months = []
      for (let i = this.oldYear; i <= date.getFullYear(); i++) {
        if (this.isActive) {
          this.years.push(
            {
              value:i,
              text:i+'年'
            }
          )
        } else {
          this.years.push(
             {
              value:i,
              text:conversion.toChinaYear(i)+'年'
            }
            )
        }
      }
      if (this.isActive) {
        this.getsolarMonthDays(this.sureYear, this.sureMonth, this.selectValue)
      } else {
        this.getlunarMonthDays(this.sureYear, this.sureMonth, this.selectValue)
      }
      if(this.isActive) {
        this.lunarHour = lunarHour.calendar
      } else {
        this.lunarHour = lunarHour.lunarHour
      }
     
      this.lunarHour.forEach((item)=> {
        item['text'] = item.label
      })
    },
    bindChange: function (e) {
      const val = e.detail.value
      let year = val[0] + this.oldYear;
      let  month = val[1] + 1;
        // day = val[2] + 1
      this.days = []
      this.months = []
      this.selectValue = e.detail.value
      this.nextFinally = false
      // 公历返回每个月天数
      if (this.isActive) {
        this.getsolarMonthDays(year, month, val)
      } else {
        this.getlunarMonthDays(year, month, val)
      }
    },
    // D=>DD,M=>MM,日，月转换 1=>01
    coverTo(num) {
      return num < 10 ? '0' + num : num
    },
    // 获取公历的月份和天数
    getsolarMonthDays(year, month, val) {
      for (let i = 1; i <= 12; i++) {
        this.months.push({
          value:i,
          text:i + '月'
        })
      }
      for (let i = 1; i <= conversion.solarDays(year, month); i++) {
        this.days.push({
          value:i,
          text:i + '日'
        })
      }
      this.leap_month = 0
      this.date = `${val[0] + this.oldYear}-${this.coverTo(val[1] + 1)}-${this.coverTo(val[2] + 1)}`
      this.hour = val[3] - 1
      let showHour = this.isHourShow ? `${val[3] != 0 ? val[3] - 1 + '时' : ''}` : ''
      this.showData = `公历 ${val[0] + this.oldYear}年${this.coverTo(val[1] + 1)}月${this.coverTo(
        val[2] + 1
      )}日 ${showHour}`
      this.showYear = `${val[0] + this.oldYear}`
      this.showMonth = `${val[1] + 1}`
      setTimeout(() => {
        this.nextFinally = true
      }, 200)
    },
    // 获取农历的月份和天数
    getlunarMonthDays(year, month, e) {
      // var e =e;
      let leap_month = conversion.leapMonth(year)
      // 返回农历 闰月没有就返回0
      for (let i = 1; i <= 12; i++) {
        this.months.push( {
          value: i,
          text: conversion.toChinaMonth(i)
        })
        if (i == leap_month) {
          this.months.push(
            {
          value: i+20,
          text: '闰' + conversion.toChinaMonth(i) 
        })
        }
      }
      // 农历返回天数
      // **leapMonth 返回闰月 conversion.leapMonth(year)
      // **monthDays 返回非闰月的天数
      // **leapDays 返回闰月的天数
      if (
        conversion.leapMonth(year) != 0 &&
        (conversion.leapMonth(year) == month || month - 1 == conversion.leapMonth(year))
      ) {
        for (let i = 1; i <= conversion.leapDays(year, conversion.leapMonth(year)); i++) {
          this.days.push({
          value:i,
          text:conversion.toChinaDay(i)
        }
            )
        }
      } else {
        let lunarMonth = ''
        if (conversion.leapMonth(year)) {
          lunarMonth = month < conversion.leapMonth(year) ? month : month - 1
        } else {
          lunarMonth = month
        }
        for (let i = 1; i <= conversion.monthDays(year, lunarMonth); i++) {
          this.days.push({
          value:i,
          text:conversion.toChinaDay(i)
        })
        }
      }
      if (e) {
        const val = e
        let year = val[0] + this.oldYear,
          month = val[1],
          day = val[2],
          hour = val[3] ? val[3] : 0,
          m = '',
          d = '',
          h = ''
        m = this.months[month]
        d = this.days[day]
        h = this.lunarHour[hour].value + '时'
        this.leap_month = month == leap_month && leap_month != 0 ? 1 : 0
        let lunarToMonth = this.coverTo(
          leap_month != 0 ? (month + 1 <= leap_month ? month + 1 : month) : month + 1
        )
        this.date = `${year}-${lunarToMonth}-${this.coverTo(day + 1)}`
        this.hour = hour - 1
        let showHour = this.isHourShow ? `${h}` : ''
        this.showData = `农历 ${conversion.toChinaYear(year)}年${m}${d} ${showHour == '24时' ? '' : showHour}`
        this.showYear = year
        this.showMonth = lunarToMonth
      }
      setTimeout(() => {
        this.nextFinally = true
      }, 150)
    },
    // 切换公历<=>农历 回显以及切换 this.$refs.yourname.switchBtb(type,data),type:"lunar" or "solar", data:{date:"1992-02-10",hour:3,leap_month:"0",type:"lunar"}
    switchBtn(type, data) {
      if (data) {
        // console.log(data,"回显")
        // 回显
        let year = this.$utils.formatDate(data.date).YYYY
        let leapMonth = type == 'solar' ? 0 : conversion.leapMonth(year),
          month = this.$utils.formatDate(data.date).MM,
          day = this.$utils.formatDate(data.date).D,
          y = year - this.oldYear,
          // m = leapMonth != 0 ? (Number(month)-1 <= leapMonth ? Number(month) - 1 : Number(month)) : Number(month) - 1,
          m =
            data.leap_month == 1
              ? Number(month)
              : leapMonth != 0
              ? Number(month) <= leapMonth
                ? Number(month) - 1
                : Number(month)
              : Number(month) - 1,
          d = day - 1,
          h = Number(data.hour) + 1
        // console.log(leapMonth,"是否闰月",m)
        this.leap_month = data.leap_month ? 1 : 0
        this.type = data.type
        this.sureYear = year // 默认弹出显示年份
        this.sureMonth = month // 默认弹出显示月份
        // console.log(m,"回显月份")
        this.selectValue = [y, m, d, h] // 默认弹出选择的状态1990-06-10 10
        // console.log(m,Number(month),leapMonth)
        // console.log(this.sureYear,this.sureMonth,this.selectValue,"回显")
      } else {
        // 农历公历互相联动切换
        if (this.type == type) {
          return false
        }
        if (type == 'lunar') {
          // 公历切换为农历
          // this.defaultYear = '一九八零'
          let solarYear = this.selectValue[0] + this.oldYear // 公历年份
          let leapMonth = conversion.leapMonth(solarYear)
          let solarMonth = this.selectValue[1] + 1, // 公历年月份
            solarDay = this.selectValue[2] + 1, // 公历年日份
            hour = this.selectValue[3]
          let lunarDate = conversion.solar2lunar(solarYear, solarMonth, solarDay)
          this.sureYear = lunarDate.lYear // 默认弹出显示年份
          this.sureMonth = lunarDate.lMonth // 默认弹出显示月份
          this.leap_month = leapMonth != 0 ? 1 : 0
          let y = lunarDate.lYear - this.oldYear,
            m =
              this.leap_month == 0
                ? lunarDate.lMonth - 1
                : this.selectValue[1] < leapMonth
                ? lunarDate.lMonth - 1
                : lunarDate.lMonth,
            d = lunarDate.lDay - 1
          this.selectValue = [y, m, d, hour] // 默认弹出选择的状态1990-06-10 10
          // console.log(this.sureYear,this.sureMonth,this.selectValue,"回显农历")
        } else {
          // 农历切换为公历
          // this.defaultYear = 1980
          let lunarYear = this.selectValue[0] + this.oldYear // 农历年份
          let leapMonth = conversion.leapMonth(lunarYear) // 一年中的几月份是闰月
          let lunarMonth =
              leapMonth == 0
                ? this.selectValue[1] + 1
                : this.selectValue[1] + 1 <= leapMonth
                ? this.selectValue[1] + 1
                : this.selectValue[1], // 农历年月份
            lunarDay = this.selectValue[2] + 1, // 农历年日份
            hour = this.selectValue[3]
          // console.log(this.selectValue[1],"月份index")
          let lunarDate = conversion.lunar2solar(
            lunarYear,
            lunarMonth,
            lunarDay,
            leapMonth == this.selectValue[1] ? true : false
          )
          // console.log(lunarDate,"回显公历全部数据")
          this.sureYear = lunarDate.cYear // 默认弹出显示年份
          this.sureMonth = lunarDate.cMonth // 默认弹出显示月份
          this.leap_month = leapMonth != 0 ? 1 : 0
          let y = lunarDate.cYear - this.oldYear,
            m = lunarDate.cMonth - 1,
            d = lunarDate.cDay - 1
          this.selectValue = [y, m, d, hour] // 默认弹出选择的状态1990-06-10 10
          // console.log(this.sureYear,this.sureMonth,this.selectValue,"回显公历")
        }
      }
      this.isActive = type == 'solar' ? true : false
      this.type = type
      this.getTime()
    },
  },
}
</script>

<style lang="scss" scoped>
.yunshui-mask {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  width: 100%;
  box-sizing: border-box;
  background: rgba(0, 0, 0, 0.7);
  z-index: 9999999;
  
.u-mask-zoom {
  transform: scale(1, 1);
}
.choose-title {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #363837;
    font-size: 18px;
    font-weight: 700;
}
.calendar {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 500px;
  margin-left: calc(50% - 262px);
  padding: 12px;
  .content {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    // height: 100%;
    background-color: #fff;
    overflow: hidden;
    border-radius: 12px;
    // border-top-left-radius: 12px;
    // border-top-right-radius: 12px;
    animation: switchOpen 500ms linear;
    @keyframes switchOpen {
      from {
        top: 100%;
      }
      to {
        top: 0%;
      }
    }
    .title {
      display: flex;
      flex-direction: row;
      align-items: center;
      width: 100%;
      height: 50px;
      position: relative;
      border-bottom: 1px solid #e6e6e6;
      background-color: #ffffff;
      border-top-left-radius: 12px;
      border-top-right-radius: 12px;
      /* #ifdef MP-WEIXIN */
      margin-top: 0;
      /* #endif */
      .switch {
        width: 70%;
        height: 40px;
        line-height: 40px;
        color: #a6a6a6;
        position: absolute;
        display: flex;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        border: 1px solid #1989fa;
        .left,
        .right {
          font-size: 16px;
          display: inline-block;
         display: flex;
         justify-content: center;
         align-items: center;
          text-align: center;
          flex:1;
          width:50%;
          color: #1989fa;
          background: #fff;
        }
        .bg {
          background-color: ea4646;
          border-radius: 30px;
          height: 3px;
          width: 20px;
          position: absolute;
          // right: 0;
          bottom: 0px;
          z-index: 0;
        }
        .active {
          color: #FFF;
          background: #1989fa;
        }
        .lunar {
          left: 63px;
          animation: switchsolar 500ms;
        }
        @keyframes switchsolar {
          0% {
            left: 12.5px;
          }
          100% {
            left: 63.5px;
          }
        }
        .solar {
          left: 12.5px;
          animation: switchlunar 500ms;
        }
        @keyframes switchlunar {
          0% {
            left: 63.5px;
          }
          100% {
            left: 12.5px;
          }
        }
      }
      .ignore-year {
        position: absolute;
        right: 15px;
      }
    }
    picker-div {
      width: 100%;
      height: 250px;
      margin: 20px auto;
      ::v-deep .item {
        display: flex;
        align-items: center;
        justify-content: center;
        color: #333333;
        font-size: 16px;
        font-weight: bold;
      }
      .uni-picker-div-wrapper {
        uni-picker-div-column {
          display: flex;
          align-items: center;
          justify-content: center;
          color: #333333;
          font-size: 16px;
          font-weight: bold;
          .uni-picker-div-group {
            .uni-picker-div-content {
              text-align: center;
              line-height: 55px;
              .item {
                display: flex;
                align-items: center;
                justify-content: center;
                color: #333333;
                font-size: 16px;
                font-weight: bold;
              }
            }
          }
        }
      }
    }
    .bottom {
      height: 50px;
      width: 100%;
      display: flex;
      background-color: #f7f7f7;
      position:absolute;
      left:0;
      bottom: 0;
      z-index: 33;
      div {
        width: 50%;
        line-height: 55px;
        text-align: center;
        font-size: 16px;
      }
      .left {
        color: #a6a6a6;
      }
      .right {
        color: #fff;
        background: #1989fa;
      }
    }
  }
}
.time-list {
  display: flex;
  width:100%;
  height: 240px;
  overflow: hidden;
}
.time-item {
  flex:1;
  width: 30%;

}
.time-item:nth-child(2) {
  width: 15%;
}
.time-item:nth-child(3) {
  width: 15%;
}
.time-item:nth-child(4) {
  width: 40%;
}
}
</style>
